// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3716) return "static/chunks/98309536-6f75991e3ca8786c.js";
	if (chunkId === 8230) return "static/chunks/8230-d6f88f10f3a952f9.js";
	if (chunkId === 8217) return "static/chunks/8217-a9faf62e4ae957c7.js";
	if (chunkId === 3541) return "static/chunks/3541-5e964ed0c58f6098.js";
	if (chunkId === 4029) return "static/chunks/4029-a3aa1a6336359372.js";
	if (chunkId === 5476) return "static/chunks/5476-5999d829c5072436.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5196 ? "de28be69" : chunkId) + "." + {"424":"022cf31044391a1b","838":"86a065ab3d8b105f","1219":"944c51afee7cc8ff","3249":"c15956ebee3d0038","5051":"78354ff6da94cbf9","5196":"0d5687d3405d0109","5929":"669758e4849aa7a7","6936":"bf56ea292b5517ba","8046":"5d344b5404586615","9114":"69377570dd82f462"}[chunkId] + ".js";
};